import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../shared/ApiService/api.service';
import { generateUuidV4 } from '../../shared/Utils/uuid.util';

@Injectable({
  providedIn: 'root'
})
export class ServiceRequestService {

  private readonly apiUrl = `${environment.grievance_base_url}/api/grievance`

  private readonly baseUrl = `${environment.base_url}/api/grievance`;

  constructor(private apiService: ApiService, private http: HttpClient) {}

  createServiceRequest(data: FormData) {
    return this.apiService.post(this.apiUrl, data);
  }

  getServiceRequests(page: number, pageSize: number, category?: string | null, subcategory?: string | null, status?: string | null) {
    let url = `${this.apiUrl}?page=${page}&per_page=${pageSize}`;

    if (category) { url += `&category_id=${category}`; }
    if (subcategory) { url += `&subcategory_id=${subcategory}`; }
    if (status) { url += `&status=${status}`; }

    return this.apiService.get(url);
  }

  getServiceRequestById(id: string) {
    return this.apiService.get(`${this.apiUrl}/${id}`);
  }

  getServiceRequestLogs(id: string) {
    return this.apiService.get(`${this.apiUrl}/${id}/logs`);
  }

  downloadServiceRequestPdf(id: string) {
    return this.http.get(`${this.apiUrl}/${id}/pdf`, { responseType: 'blob' });
  }

  resubmitServiceRequest(id: string, data: FormData) {
    const headers = new HttpHeaders({
      'Idempotency-Key': generateUuidV4(),
    });

    return this.apiService.post(`${this.apiUrl}/${id}`, data, { headers });
  }

  reopenServiceRequest(id: string, data: FormData) {
    return this.apiService.post(`${this.apiUrl}/${id}/reopen`, data);
  }

  getServiceRequestStats() {
    return this.apiService.get(`${this.apiUrl}/stats`);
  }

  getExamSchedules(contractId: string) {
    const url = `${environment.base_url}/grievance-redressal/schedules-by-contract?contract_id=${encodeURIComponent(contractId)}`;
    return this.apiService.get(url);
  }

  getScheduleLookupByExamNo(examNo: string | number) {
    const url = `${this.apiUrl}/schedules/lookup?exam_no=${encodeURIComponent(examNo)}`;
    return this.apiService.get(url);
  }

  private featureAccess$?: Observable<any>;

  getFeatureAccess() {
    if (!this.featureAccess$) {
      const url = this.apiUrl.replace('/api/grievance','/api') +`/feature-access`;
      this.featureAccess$ = this.apiService.get(url).pipe(shareReplay(1));
    }
    return this.featureAccess$;
  }

  submitServiceRequestFeedback(payload: { grievance_id: string; rating: number; description?: string }): Observable<any> {
    const url = this.apiUrl.replace('/grievance', '/grievance-rating');
    return this.apiService.post(url, payload);
  }
}
